import NepaliDate from 'nepali-date-converter';

// Convert English numbers to Nepali digits
export const toNepaliDigits = (number) => {
    const nepaliDigits = ['०', '१', '२', '३', '४', '५', '६', '७', '८', '९'];
    return number.toString().replace(/\d/g, (digit) => nepaliDigits[digit]);
};

// Get Nepali month names
export const getNepaliMonthNames = () => ({
    en: {
        '01': 'Baishakh',
        '02': 'Jestha',
        '03': 'Ashadh',
        '04': 'Sharawan',
        '05': 'Bhadra',
        '06': 'Ashwin',
        '07': 'Kartik',
        '08': 'Mangsir',
        '09': 'Poush',
        '10': 'Magh',
        '11': 'Falgun',
        '12': 'Chaitra'
    },
    ne: {
        '01': 'बैशाख',
        '02': 'जेठ',
        '03': 'असार',
        '04': 'श्रावण',
        '05': 'भदौ',
        '06': 'आश्विन',
        '07': 'कार्तिक',
        '08': 'मङ्सिर',
        '09': 'पौष',
        '10': 'माघ',
        '11': 'फाल्गुन',
        '12': 'चैत्र'
    }
});

// Generate years list (2079-2200)
export const generateNepaliYears = () => {
    const years = [];
    for (let year = 2079; year <= 2200; year++) {
        years.push({ name: year, value: year });
    }
    return years;
};

// Format Nepali date
export const formatNepaliDate = (date, format = 'YYYY-MM-DD') => {
    const nepaliDate = date instanceof NepaliDate ? date : new NepaliDate(date);
    const year = toNepaliDigits(nepaliDate.getYear());
    const month = toNepaliDigits(nepaliDate.getMonth() + 1);
    const day = toNepaliDigits(nepaliDate.getDate());
    
    return format
        .replace('YYYY', year)
        .replace('MM', month)
        .replace('DD', day);
};

// Get current Nepali date
export const getCurrentNepaliDate = () => {
    return new NepaliDate();
};